export enum TravelReminderTypeEnum {
  ISSUANCE_DATE = 'ISSUANCE_DATE',
  RETROCESSION_DATE = 'RETROCESSION_DATE',
  BALANCE_PAYMENT_DATE = 'BALANCE_PAYMENT_DATE',
  APIS_SENDING_DATE = 'APIS_SENDING_DATE'
}

export const TravelReminderTypeEnumMapping: Record<TravelReminderTypeEnum, string> = {
  ISSUANCE_DATE: "Date d'émission",
  RETROCESSION_DATE: 'Date de rétrocession',
  BALANCE_PAYMENT_DATE: 'Date de paiement du solde',
  APIS_SENDING_DATE: "Date d'envoi des APIS"
}
